import { Injectable } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { BehaviorSubject } from 'rxjs';

export interface BreakpointsToValidate {
  isXSmall: boolean;
  isSmall: boolean;
  isMedium: boolean;
  isLarge: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class BreakpointObserverService {
  private initialBreakpoints = {
    isXSmall: false,
    isSmall: false,
    isMedium: false,
    isLarge: false,
  };

  public screenSizeObserver = new BehaviorSubject<BreakpointsToValidate>(
    this.initialBreakpoints
  );

  constructor(private breakpointObserver: BreakpointObserver) {
    this.initObservers();
  }

  private initObservers(): void {
    this.breakpointObserver
      .observe([
        Breakpoints.XSmall,
        Breakpoints.Small,
        Breakpoints.Medium,
        Breakpoints.Large,
        Breakpoints.XLarge,
      ])
      .subscribe((result) => {
        if (result.breakpoints[Breakpoints.XSmall]) {
          const breakpoints = { ...this.initialBreakpoints, isXSmall: true };
          this.screenSizeObserver.next(breakpoints);
        }
        if (result.breakpoints[Breakpoints.Small]) {
          const breakpoints = { ...this.initialBreakpoints, isSmall: true };
          this.screenSizeObserver.next(breakpoints);
        }
        if (result.breakpoints[Breakpoints.Medium]) {
          const breakpoints = { ...this.initialBreakpoints, isMedium: true };
          this.screenSizeObserver.next(breakpoints);
        }
        if (
          result.breakpoints[Breakpoints.Large] ||
          result.breakpoints[Breakpoints.XLarge]
        ) {
          const breakpoints = { ...this.initialBreakpoints, isLarge: true };
          this.screenSizeObserver.next(breakpoints);
        }
      });
  }
}
